module.exports = __webpack_public_path__ + "img/fond_projets.ad9cbcbf.jpg";